import { createStyles, Theme } from '@material-ui/core'

const FieldValuePairStyles = (theme: Theme) => createStyles({
  wrapper: {
    padding: theme.spacing(1),
    paddingLeft: 0,
    paddingRight: 0,
  },
  fieldName: {
    color: '#00000054',
  },
})

export default FieldValuePairStyles
